<template>
  <div class="tags-editor">
    <h2>Tags</h2>


    <div v-for="[tag, tagDefinition] in tagsDefinitions">
      <div class="tag-definition" :style="{'background-color': tagDefinition.color}">{{ tag }}
        <i class="material-icons delete" @click="deleteTagDefinition(tag)">close</i>
        <input type="color" :value="tagDefinition.color" @change="setTagDefinition(tag, $event.target.value)">

      </div>

    </div>
    <div class="add-tag-definition">
      <input placeholder="add tag" type="text" v-model="newTag" @keyup.enter="addTagDefinition(newTag)"><a
      @click="addTagDefinition(newTag)" v-show="newTag">
      <i class="material-icons">add</i></a>
    </div>
  </div>
</template>

<script>
  import { mapMutations } from 'vuex'

  export default {
    name: 'tagsEditor',
    props: [],
    data () {
      return {
        'newTag': ''
      }
    },
    computed: {
      tagsDefinitions () {
        return Object.entries(this.$store.state.tagsDefinitions)
      }
    },
    methods: {
      ...mapMutations(['deleteTagDefinition']),
      addTagDefinition (tag) {
        this.$store.commit('setTagDefinition', {
          tag,
          color: '#' + (Math.floor(Math.random() * 2 ** (8 * 3))).toString(16)
        })
        this.newTag = ''
      },
      setTagDefinition (tag, color) {
        this.$store.commit('setTagDefinition', {tag, color})
      }
    },
    components: {}
  }
</script>

<style lang="scss">
  @import "../styles/settings";

  $max-width: 240px;
  .tags-editor {
    .tag-definition {
      padding: 0.5rem;
      text-shadow: $default-text-shadow;
      font-size: 1rem;
      max-width: $max-width;
      box-shadow: $default-shadow;
      margin-bottom: 0.5rem;
      input {
        float: right;
        cursor: pointer;
      }
      .delete {
        float: right;
        cursor: pointer;
        padding-left: 0.5rem;
      }
    }
    .add-tag-definition {
      max-width: $max-width;
      position: relative;
      .material-icons {
        font-size: 1rem;
        position: absolute;
        right: 0;
        top: 0.5rem;
        font-weight: bold;
      }
      input {
        width: 100%;

        -webkit-appearance: none;
        background-color: rgba(0, 0, 0, 1);
        border: 0;
        font-size: 1rem;

        display: block;
        border: none;
        padding: .5rem 0;
        border-bottom: solid 1px $search-color;
        background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 99%, $search-color 1%);

        background-repeat: no-repeat;
        color: darken($search-color, 20%);
        &:focus {
          background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 96%, $search-color 4%);
        }

        &:focus, &:valid {
          box-shadow: none;
          outline: none;
          background-position: 0 0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// TagsEditor.vue?2a39efa6